import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';

import styles from './DataSourcesLink.module.scss';

interface DataSourcesLinkProps {
    /** Null for those who may not open the page, or while the flag is off. */
    href: string | null;
    labelKey: string;
    /** Outside a sentence, so it needs no space before it. */
    standalone?: boolean;
}

/** A link to the site's data sources page, where an unmapped signal is set up. */
export function DataSourcesLink({ href, labelKey, standalone = false }: DataSourcesLinkProps) {
    const { t } = useTranslation();
    if (href === null) return null;
    return (
        <Button to={href} variant="link" className={standalone ? undefined : styles.inSentence}>
            {t(labelKey)}
        </Button>
    );
}
